import { dispatchSessionExpiredEvent } from './sessionExpiredEvent';

/**
 * Wrapper autour de fetch qui :
 *  - injecte automatiquement le token JWT depuis localStorage
 *  - intercepte les 401 → déclenche la modale "Session expirée" et lève une erreur
 *
 * Utilisation identique à fetch() :
 *   const r = await fetchWithAuth('/url', { method: 'POST', body: JSON.stringify(data) });
 *   const json = await r.json();
 */
export async function fetchWithAuth(url, options = {}) {
  const token = localStorage.getItem('auth_token');

  const mergedHeaders = { 'Content-Type': 'application/json', ...(options.headers || {}) };
  if (token) mergedHeaders['Authorization'] = `Bearer ${token}`;

  const response = await fetch(url, { ...options, headers: mergedHeaders });

  if (response.status === 401) {
    dispatchSessionExpiredEvent();
    throw new Error('Session expirée');
  }

  return response;
}
